import supabase from './supabase';

export interface UserBookshelf {
  id?: number;
  user_id: string;
  quest_ids: string[];
  created_at?: string;
}

export class UserBookshelfService {
  /**
   * Get user bookshelf by user_id
   */
  static async getBookshelf(userId: string): Promise<UserBookshelf | null> {
    try {
      const { data, error } = await supabase
        .from('user_bookshelf')
        .select('*')
        .eq('user_id', userId)
        .maybeSingle();

      if (error) {
        if (error.code !== 'PGRST116') { // not found
          console.error('Error fetching user bookshelf:', error);
        }
        return null;
      }

      return data as UserBookshelf;
    } catch (error) {
      console.error('Error in getBookshelf:', error);
      return null;
    }
  }

  /**
   * Update user bookshelf (upsert)
   */
  static async updateBookshelf(userId: string, questIds: string[]): Promise<UserBookshelf | null> {
    try {
      const { data, error } = await supabase
        .from('user_bookshelf')
        .upsert({
          user_id: userId,
          quest_ids: questIds,
        }, {
          onConflict: 'user_id'
        })
        .select()
        .single();

      if (error) {
        console.error('Error updating user bookshelf:', error);
        return null;
      }

      return data as UserBookshelf;
    } catch (error) {
      console.error('Error in updateBookshelf:', error);
      return null;
    }
  }

  /**
   * Remove a quest from bookshelf
   */
  static async removeQuest(userId: string, questId: string): Promise<UserBookshelf | null> {
    try {
      // Get current bookshelf
      const currentBookshelf = await this.getBookshelf(userId);
      const currentQuestIds = currentBookshelf?.quest_ids || [];

      // Remove the quest
      const newQuestIds = currentQuestIds.filter(id => id !== questId);
      return await this.updateBookshelf(userId, newQuestIds);
    } catch (error) {
      console.error('Error in removeQuest:', error);
      return null;
    }
  }
}

export default UserBookshelfService;
